// A key typed into a box is the box's (issue 1422): a label's "a" or a hit-points box's Ctrl+A never moves the selected
// token, reveals it or deletes it. The board's keys and the tools' window-wide keys ask this first; Escape, which only
// leaves a tool, stays theirs.
export const typingIn = (t: EventTarget | null): boolean => {
  if (!(t instanceof HTMLElement)) return false;
  if (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT') return true;
  // jsdom has no isContentEditable; the attribute is the same answer in a browser.
  return t.isContentEditable === true || !!t.closest('[contenteditable]:not([contenteditable="false"])');
};
